import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home';
import Wizard from '@/views/Wizard';
import ScoringEvent from '@/views/ScoringEvent';
import NewScoringEvent from '@/views/NewScoringEvent';
import QuickWinRecommendationSearch from '@/views/QuickWinRecommendationSearch';
import GPCSessions from '@/views/GPCSessions';
import IndustryData from '@/views/IndustryData';
import ScoringEvents from '@/views/ScoringEvents';
import GoalSetting from '@/views/GoalSetting';
import MultiAnalyse from '@/views/MultiAnalyse';
import EditScoringEvent from '@/views/EditScoringEvent';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/scoring-events',
      name: 'Scoring Events',
      component: ScoringEvents
    },
    {
      path: '/wizard',
      name: 'Wizard',
      component: Wizard
    },
    {
      path: '/new-scoring-event',
      name: 'New Scoring Event',
      component: NewScoringEvent
    },
    {
      path: '/scoring-event/:id',
      name: 'Scoring Event',
      component: ScoringEvent
    },
    {
      path: '/edit-scoring-event/:id',
      name: 'Edit Scoring Event',
      component: EditScoringEvent
    },
    {
      path: '/quick-win-recommendation-search',
      name: 'Quick Win and Recommendation Search',
      component: QuickWinRecommendationSearch
    },
    {
      path: '/gpc-sessions',
      name: 'GPC Sessions',
      component: GPCSessions
    },
    {
      path: '/industry-data',
      name: 'Industry Data',
      component: IndustryData
    },
    {
      path: '/smart-goals',
      name: 'SMART Goals',
      component: GoalSetting
    },
    {
      path: '/multi-analyse',
      name: 'Analyse Multiple Scoring Events',
      component: MultiAnalyse
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js